export default __webpack_public_path__ + "static/media/4cf15bb66bff2681d5137b61942646c3.png";